// extracted by mini-css-extract-plugin
export default {"comment-adding":"CommentAddingLoading_comment-adding__q8V4+","send-button":"CommentAddingLoading_send-button__iSVN1","comment-input":"CommentAddingLoading_comment-input__VWxYP"};